import type { Entity, Persisted } from '@tunasong/schemas'

/** How many cards the Home Continue shelf shows, pinned items included */
export const continueCap = 6

interface MergeContinueItemsInput {
  /** Pinned entity ids in pin order */
  pinnedIds: string[]
  /** My recently edited entity ids, most recent first */
  mineIds: string[]
  entitiesById: Map<string, Persisted<Entity>>
  cap?: number
}

/**
 * The Home Continue shelf: pinned items first (in pin order), then my recent edits. An item that is both
 * pinned and recent shows once, in its pinned slot. Ids that no longer resolve, and trashed entities, are
 * dropped rather than rendered as broken cards.
 */
export const mergeContinueItems = (input: MergeContinueItemsInput): Persisted<Entity>[] => {
  const { pinnedIds, mineIds, entitiesById, cap = continueCap } = input
  const orderedIds = [...new Set([...pinnedIds, ...mineIds])]
  return orderedIds
    .map(id => entitiesById.get(id))
    .filter((e): e is Persisted<Entity> => Boolean(e) && !e?.trash)
    .slice(0, cap)
}
